import { TextField, styled } from "@mui/material";
import theme from "common/theme/theme";

const DialogDropdownTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    position: "relative",
    top: "-10px",
    left: "-8px",
    backgroundColor: "white",
    paddingRight: "5px",
  },
  "& .MuiSelect-select:hover": {
    backgroundColor: theme.accent.hover, // Background hover color when closed
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "0px", // This removes the rounded borders
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "black", // This sets the border color to black
  },
});

export default DialogDropdownTextField;
